import { Label } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openNewbuildingBrokerCallbackWidget } from 'shared/actions/newbuildingBrokerOfferBooking/actions';
import { getOfferCustomUrl } from 'shared/selectors/analytics';
import { selectOfferBookingEnabled } from 'shared/selectors/newbuildingBrokerOfferBooking';
import { trackCallbackWidgetOpen } from 'shared/utils/newbuildingBroker/offerBooking';

import { ClickIcon } from './parts/ClickIcon';

export function OfferBookingLabelContainer() {
  const dispatch = useDispatch();

  const gaLabel = useSelector(getOfferCustomUrl);

  const handleClick = React.useCallback(() => {
    dispatch(openNewbuildingBrokerCallbackWidget('main_label'));
    trackCallbackWidgetOpen(gaLabel, 'main_label');
  }, [dispatch, gaLabel]);

  const isOfferBookingEnabled = useSelector(selectOfferBookingEnabled);

  if (!isOfferBookingEnabled) {
    return null;
  }

  return (
    <Label
      color="accent-main-primary"
      background="accent-main-secondary"
      icon={<ClickIcon />}
      rightIcon={<IconActionChevronRightSmall16 color="icon-main-default" />}
      onClick={handleClick}
      tabIndex={0}
    >
      Онлайн-бронирование
    </Label>
  );
}
